import { defineEnvVariable } from '@nzyme/ioc/defineEnvVariable.js';
export const STRIPE_PUBLISHABLE_KEY = defineEnvVariable('STRIPE_PUBLISHABLE_KEY');
//# sourceMappingURL=stripeEnv.js.map